<template>
  <div class="jurisdiction x-margin x-border-50">
    <my-head-title showBack :title="name"></my-head-title>
    <ul class="ul-list">
      <li class="x-flex-align x-padding-y">
        <i class="title-label">{{$t('HT.jurisdiction.label1')}}</i>
        <i class="title-label">{{$t('HT.jurisdiction.label2')}}</i>
        <i class="x-flex-one">{{$t('HT.jurisdiction.label3')}}</i>
        <i class="all-election x-flex-center">{{$t('HT.deviceManage.checkAll')}}</i>
      </li>
      <li class="x-flex-start" v-for="(item, index) in powerData" :key="index">
        <i class="hundred">{{ item.menu_name }}</i>
        <i class="powers">
          <template v-if="item.child_menu && item.child_menu.length">
            <div class="x-flex-start model" v-for="(child, val) in item.child_menu" :key="val">
              <div class="hundred">{{ child.menu_name }}</div>
              <div class="x-flex-one">
                <template v-for="(data, i) in child.auth_list">
                  <ux-checkbox
                    :value="data.selected"
                    :false-label="0"
                    :true-label="1"
                    :key="i"
                    @change="changeBox($event, data, child[propsKey.modules])"
                    >{{ data.module_name }}</ux-checkbox
                  >
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="x-flex-start model">
              <div class="hundred"></div>
              <div class="x-flex-one">
                <template v-for="(data, i) in item.auth_list">
                  <ux-checkbox
                    :value="data.selected"
                    :false-label="0"
                    :true-label="1"
                    :key="i"
                    @change="changeBox($event, data, item[propsKey.modules])"
                    >{{ data.module_name }}</ux-checkbox
                  >
                </template>
              </div>
            </div>
          </template>
        </i>
        <i class="all-election x-flex-center">
          <ux-checkbox
            :value="item['checkAll'] || 0"
            :false-label="0"
            :true-label="1"
            @change="changeAll($event, index)"
          ></ux-checkbox>
        </i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      group_id: this.$route.params.id, // 群组id
      name: this.$route.query.name, // 群组名称
      powerData: [],
      flag: false,
      propsKey: {
        name: 'menu_name', // 菜单名
        children: 'child_menu', // 子菜单列表
        selected: 'selected', // 是否选中
        modules: 'auth_list', // 权限列表
        module_name: 'module_name' // 权限名字
      }
    };
  },
  created() {
    this.getPower(this.group_id);
  },

  methods: {
    /**
     * 节流勾选
     */
    debounce: _.debounce(function (val, item, data) {
      this.flag = true;
      let res = this.initCheckBox(val, item, data); // 0为取消仅查看 1为勾选权限任意1项
      this.judegCheckAll(); // 判断是否全选
      let postData = {
        group_id: this.group_id,
        auth_list: [{ auth_id: item.auth_id, selected: val }]
      };
      if (res === 0) {
        let list = [];
        for (let i = 0; i < data.length; i++) {
          list.push({
            auth_id: data[i].auth_id,
            selected: 0
          });
        }
        postData.auth_list = list;
      } else if (res === 1) {
        postData.auth_list.push({
          auth_id: data[0].auth_id,
          selected: 1
        });
      }
      this.setPower(postData);
    }, 300),

    /**
     * 节流全选
     */
    debounceAll: _.debounce(function (val, index) {
      this.flag = true;
      let child = this.propsKey.children;
      let modules = this.propsKey.modules;
      let selected = this.propsKey.selected;
      let item = this.powerData[index][child];
      let res = [];
      if (item && item.length) {
        // 有子模块
        for (let i = 0; i < item.length; i++) {
          let dataArray = item[i][modules];
          for (let j = 0; j < dataArray.length; j++) {
            this.powerData[index][child][i][modules][j][selected] = val;
            res.push({
              auth_id: dataArray[j].auth_id,
              selected: val
            });
          }
        }
      } else {
        // 无子模块
        for (let i = 0; i < this.powerData[index][modules].length; i++) {
          this.powerData[index][modules][i][selected] = val;
          res.push({
            auth_id: this.powerData[index][modules][i].auth_id,
            selected: val
          });
        }
      }
      let postData = {
        group_id: this.group_id,
        auth_list: res
      };
      this.setPower(postData);
    }, 300),

    /**
     * 获取群组的权限
     * @param {String} id 群组id
     */
    getPower(id) {
      this.$api.user.getPower(id).then((res) => {
        if (res.code == 10000) {
          this.powerData = res.data;
          this.judegCheckAll(); // 判断是否全选
        }
      });
    },

    /**
     * 配置群组的权限
     * @param {Object} postData 提交数据
     */
    setPower(postData) {
      this.$api.user.setPower(postData).then((res) => {
        this.flag = false;
        if (res.code == 10000) {
          this.$uxMessage.success(this.$t('HT.addApi.operateSuccess'));
        }
      });
    },

    /**
     * 勾选权限
     * @param {Number} val 当前勾选的值
     * @param {Object} item 当前对象
     * @param {Array} data 当前权限列表
     */
    changeBox(val, item, data) {
      if (!this.flag) {
        item[this.propsKey.selected] = val;
        this.debounce(val, item, data);
      }
    },

    /**
     * 勾选全选
     * @param {Boolean} val 返回值
     * @param {Number} index 索引
     */
    changeAll(val, index) {
      if (!this.flag) {
        this.powerData[index]['checkAll'] = val;
        this.debounceAll(val, index);
      }
    },

    /**
     * 勾选的联动操作
     * @param {Number} val 当前勾选的值
     * @param {Object} item 当前对象
     * @param {Array} data 当前权限列表
     */
    initCheckBox(val, item, data) {
      let nameKey = this.propsKey.module_name;
      let selected = this.propsKey.selected;
      if (val === 0 && item[nameKey] === this.$t('HT.jurisdiction.read')) {
        // 取消仅查看, 此模块所有权限都不勾选
        for (let index = 0; index < data.length; index++) {
          data[index][selected] = 0;
        }
        return 0;
      }
      if (val === 1 && item[nameKey] !== this.$t('HT.jurisdiction.read')) {
        // 勾选其中一个权限, '仅查看'权限也一并勾选
        data[0][selected] = 1;
        return 1;
      }
    },

    /**
     * 判断是否全选
     */
    judegCheckAll() {
      let child = this.propsKey.children;
      let modules = this.propsKey.modules;
      let selected = this.propsKey.selected;
      for (let index = 0; index < this.powerData.length; index++) {
        let item = this.powerData[index];
        let flag = true;
        if (item[child]) {
          for (let i = 0; i < item[child].length; i++) {
            let dataArray = item[child][i][modules];
            if (!flag) {
              break;
            }
            for (let j = 0; j < dataArray.length; j++) {
              let res = this.powerData[index][child][i][modules][j][selected];
              if (res === 0) {
                // 如果有没有勾选的, 更改标记
                flag = false;
                break;
              }
            }
          }
        } else {
          for (let i = 0; i < item[modules].length; i++) {
            let res = this.powerData[index][modules][i][selected];
            if (res === 0) {
              flag = false;
              break;
            }
          }
        }
        this.$set(this.powerData, index, { ...this.powerData[index], checkAll: flag ? 1 : 0 });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.jurisdiction {
  .ul-list {
    padding: 0 50px 20px 50px;

    > li {
      position: relative;
      padding: 15px 15px 0 15px;
      border-bottom: 1px solid #e8ecf2;

      .powers {
        flex: 1;

        .ux-checkbox {
          display: inline-block;
          box-sizing: border-box;
          width: 25%;
          margin: 0 0 15px 0;
        }
      }

      .model {
        margin-bottom: 5px;
      }
    }

    > li:first-child {
      padding: 15px;
    }

    .all-election {
      width: 50px;
    }

    .title-label {
      width: 130px;
    }

    .hundred {
      width: 130px;
      margin-bottom: 15px;
    }
  }
}
</style>
